import {
  FETCH_PROMOS,
  FETCH_PROMOS_SUCCESS,
  FETCH_PROMOS_FAILED,
  EDIT_PROMOS
} from "../store/types";
import { cloud_function_server_url } from '../../config';

const END_POINT = `${cloud_function_server_url}/transaction`;

export const fetchPromos = () => (dispatch) => (firebase) => {

  const {
    promoRef
  } = firebase;

  dispatch({
    type: FETCH_PROMOS,
    payload: null
  });

  fetch(`${END_POINT}/fetch-offers`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      if (response?.success) {
        const arr = response.data?.map((item) => {
          item.id = item._id;
          if (item.user_avail) {
            item.promo_used_by = item.user_avail.count;
          }
          return item;
        });

        console.log("fetchPromos", response, arr)
        dispatch({
          type: FETCH_PROMOS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_PROMOS_FAILED,
          payload: "No promos available."
        });
      }
    }).catch(error => {
      dispatch({
        type: FETCH_PROMOS_FAILED,
        payload: "No promos available."
      });
      console.log("fetchPromos error", error)
    });

  // promoRef.on("value", snapshot => {
  //   if (snapshot.val()) {
  //     const data = snapshot.val();
  //     const arr = Object.keys(data).map(i => {
  //       data[i].id = i
  //       if (data[i].user_avail) {
  //         data[i].promo_used_by = data[i].user_avail.count;
  //       }
  //       return data[i]
  //     });
  //     dispatch({
  //       type: FETCH_PROMOS_SUCCESS,
  //       payload: arr
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_PROMOS_FAILED,
  //       payload: "No promos available."
  //     });
  //   }
  // });
};

export const addPromo = (promos) => (dispatch) => (firebase) => {

  dispatch({
    type: EDIT_PROMOS,
    payload: "Add"
  });

  fetch(`${END_POINT}/add-promo`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({data: promos})
  })
    .then(async (res) => {
      const response = await res.json();
      if(response?.success) {
        fetchPromos()(dispatch)(firebase);
      }
      console.log("addPromo res", response)
    }).catch(error => {
      console.log("addPromo error", error)
    });
}

export const editPromo = (promos) => (dispatch) => (firebase) => {
  dispatch({
    type: EDIT_PROMOS,
    payload: "Update"
  });

  fetch(`${END_POINT}/edit-promo/${promos.id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({data: promos})
  })
    .then(async (res) => {
      const response = await res.json();
      if(response?.success) {
        fetchPromos()(dispatch)(firebase);
      }
      console.log("editPromo res", response)
    }).catch(error => {
      console.log("editPromo error", error)
    });
}

export const deletePromo = (promos) => (dispatch) => (firebase) => {

  dispatch({
    type: EDIT_PROMOS,
    payload: "Delete"
  });

  fetch(`${END_POINT}/delete-promo/${promos.id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      if(response?.success) {
        fetchPromos()(dispatch)(firebase);
      }
      console.log("deletePromo res", response)
    }).catch(error => {
      console.log("deletePromo error", error)
    });
}